import { ChangeEvent, ReactElement } from 'react'
import { FormHelperText, Input, InputLabel } from '@mui/material'

interface Props {
  value: number
  placeholder: string
  label: string
  validationMessage?: string
  onChange: (value: number) => void
}

const DevelopusInputNumber = (props: Props): ReactElement => {
  const onChange = (ev: ChangeEvent<HTMLInputElement>) => {
    props.onChange(parseFloat(ev.target.value))
  }

  return (
    <div style={{ padding: '20px' }}>
      <InputLabel
        sx={{
          textTransform: 'capitalize',
          display: 'inline-block',
          minWidth: '180px',
          verticalAlign: 'bottom',
        }}
      >
        {props.label}
      </InputLabel>
      <Input
        sx={{ display: 'inline-block', verticalAlign: 'bottom', width: '60px' }}
        type="number"
        placeholder={props.placeholder}
        value={props.value}
        onChange={onChange}
        error={Boolean(props.validationMessage)}
      />
      <FormHelperText
        sx={{
          marginLeft: '10px',
          display: props.validationMessage ? 'inline-block' : 'none',
          verticalAlign: 'bottom',
        }}
        error={Boolean(props.validationMessage)}
      >
        {props.validationMessage}
      </FormHelperText>
    </div>
  )
}

export default DevelopusInputNumber
